export default function setDropdownValues(dataObj, fromPage) {    
  if (!dataObj) {
    throw Error("Need data Object to work on");
  }
  var obj = dataObj.data ? dataObj.data : [];
  var selector = typeof dataObj.selector != "string" ? "" : dataObj.selector;
  var DEFAULTS = dataObj.defaults ? dataObj.defaults : {};
  var properties = dataObj.properties ? dataObj.properties : {};

  var dataKeys = Object.keys(properties);

  if (!obj || !obj[selector]) return;

    let values = obj[selector];
    let arr = values.map((item, index) => {       
        var tempObj = {};        
        dataKeys.forEach(
            
            el => {
                if (dataObj.selector == "taskTypes") {
                    var labels = properties[el].split(",");
                    tempObj[el] = labels.length > 1 ? item[DEFAULTS[selector][labels[0]]] + " (" + item[DEFAULTS[selector][labels[1]]] + ")" : item[DEFAULTS[selector][labels[0]]];
                }                  
                else if (dataObj.selector == "clientGroups") {
                    var labels = properties[el].split(",");     
                    tempObj[el] = labels.length > 1 ? item[DEFAULTS[selector][labels[0]]] + (item[DEFAULTS[selector][labels[1]]].trim().length > 0 ? " - " + item[DEFAULTS[selector][labels[1]]] : "") : item[DEFAULTS[selector][labels[0]]]; 
                }
                else {
                    (tempObj[el] = item[DEFAULTS[selector][properties[el]]])
                }                    
            }                       
    );                                                                                          
    return tempObj;
  });
  if (dataObj.selector == "firmBranches" && !fromPage) {
    return arr;
  }
  if (dataObj.selector == "pageDetails" && fromPage == "fromBulkEdit") {
    return arr;
    }
    if (dataObj.selector == "timeZones" && !fromPage) {
        return arr;
    }
  return fromPage == "fromBulkEdit"
    ? [{ key: 0, value: 0, text: "Blank" }, ...arr] : arr
  //: [{ id: "", label: "", value: "" }, ...arr];
}
